<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col class="Full-Course-Library-Title"> Full Course Library </v-col>
      </v-row>
      <v-row class="sm-mt-20 course-filter">

        <v-btn color="primary" outlined @click.prevent="showCreatePanel" class="add-course-button">
          Add New Course
        </v-btn>

        <v-text-field class="search-box" placeholder="Search Courses" prepend-icon="fa-search" v-model="search"
          type="text" clearable clear-icon="fa-times" @click:clear="resetSearch" @change="applySearch"></v-text-field>
        <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
          placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
          v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below"
          @click:clear="handleClear">
          <template v-slot:selection="{ item, index }">
            <template v-if="index < 2">
              <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
            </template>
            <template v-if="index === 2">
              <v-chip>...</v-chip>
            </template>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="grey darken-1" class="text-capitalize course-sorting" v-bind="attrs" v-on="on">
              Sort courses by...
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-card class="pa-2">
            <v-radio-group v-model="selectedSort" @change="handleSortingChange">
                    <template v-for="(option, index) in sortOptions">
              <v-radio  :key="option.value" :label="option.label" :value="option.value"
                color="primary"></v-radio>
                 <!-- Add divider after 'View All' (assuming it's the first item) -->
        <v-divider v-if="option.value === 'view_all'" :key="'divider-' + index" class="my-1 mb-2"></v-divider>
         </template>
            </v-radio-group>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>

        <div class="course-view-toggle d-flex align-center">
          <span class="mr-2 view-toggle-label">View</span>
          <v-btn-toggle
            v-model="viewMode"
            dense
            rounded
            mandatory
            class="view-toggle-buttons"
          >
            <v-btn small value="table">
              Table
            </v-btn>
            <v-btn small value="cards">
              Cards
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop && viewMode === 'table'" type="table"
              :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop && viewMode === 'table'" type="table"
              :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}"
              class="slider-table"></v-skeleton-loader>
            <v-row
              v-if="loading && viewMode === 'cards' && currentPage === 1"
              dense
              class="course-cards-grid"
            >
              <v-col
                v-for="n in 10"
                :key="'skeleton-' + n"
                cols="12"
                sm="6"
                md="4"
                class="five-wide-col"
              >
                <v-card class="modern-course-card" outlined>
                  <v-skeleton-loader
                    type="image"
                    height="200"
                  />
                  <v-skeleton-loader
                    type="heading"
                    class="mt-3 mx-3"
                  />
                  <v-skeleton-loader
                    type="actions"
                    class="px-3 pb-3"
                  />
                </v-card>
              </v-col>
            </v-row>
            <template v-if="viewMode === 'table'">
            <v-data-table v-model="selected" :headers="headers" :options.sync="options"
              :server-items-length="serverItemsLength" :items="courses" item-key="id" class="course-action-btn"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }" ref="dataTable" v-show="!loading">
              <template v-slot:header.published="{ header }">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div style="">
                      Published
                      <!-- <v-img
                        v-bind="attrs"
                        v-on="on"
                        :src="questionIconUrl"
                        width="12px"
                        class="published-icon mt-1"
                      ></v-img> -->
                      <v-icon color="primary">mdi-help</v-icon>
                    </div>
                  </template>
                  <span>Publish the Courses to make it visible to assigned
                    Users.<br />Unpublish them to hide the Course while you add
                    content or <br />customise it</span>
                </v-tooltip>
              </template>
              <template class="d-flex-inline" v-slot:item.name="{ item }">
                <div class="sm-inline-flex text-center">
                  <table-thumb :thumb="item"></table-thumb>
                  <span class="three-dots ml-2 mt-auto mb-auto">{{
                    item.name
                    }}</span>
                  <v-tooltip right v-if="item.courseUpdateNotification">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip class="three-dots ml-2 mt-auto mb-auto square update" outlined medium v-bind="attrs"
                        v-on="on" v-if="item.courseUpdateNotification.data.type == 'Update'">
                        UPDATED
                      </v-chip>
                      <v-chip class="three-dots ml-2 mt-auto mb-auto square new" medium v-bind="attrs" v-on="on"
                        v-if="item.courseUpdateNotification.data.type == 'New'">
                        NEW
                      </v-chip>
                    </template>
                    <span v-html="item.courseUpdateNotification.data.description"></span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.published="{ item }">
                <!--<v-icon v-if="item.published" color="green" small>fa-check</v-icon>-->
                <v-switch v-model="item.published" :value="$globalConfig.APP_NAME === 'direct' 
                          ? (item.published === 1 ? 1 : 0) 
                          : (item.published === true ? true : false)" @change="publishCourses(item.id, item.published)"
                  color="primary" :disabled="item.is_course_archived">
                </v-switch>
              </template>
              <!--<template v-slot:item.completion_progress="{ item }">
                <v-progress-linear height="20" color="blue" :value="item.completion_progress"></v-progress-linear>
              </template>-->

              <template v-slot:item.id="{ item }">
                <v-select v-if="screenSize === 'tablet' || screenSize === 'mobile'" v-model="selectedAction"
                  :items="getActionList(item)" item-text="name" item-value="id" placeholder="Select Action"
                  @change="performAction(item)" :item-disabled="action => action.is_course_archived"></v-select>

                <template v-else>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="redirectTo('/admin/courses/detail/' + item.id)"
                        :disabled="item.is_course_archived">
                        View
                      </v-btn>
                    </template>
                    <span>See the course from a User's view</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="showEditPanel(item.id)" :disabled="item.is_course_archived">
                        Details
                      </v-btn>
                    </template>
                    <span>View & edit the course’s information</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="redirectTo('/admin/courses/' + item.id)" :disabled="item.is_course_archived">
                        Content
                      </v-btn>
                    </template>
                    <span>Add & manage the course content</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="showEnrolPanel(item.id, 1, item.name)" :disabled="item.is_course_archived">
                        Enrol
                      </v-btn>
                    </template>
                    <span>Enrol users/groups onto this course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="showUnEnrolPanel(item.id, 1, item.name)" :disabled="item.is_course_archived">
                        Unenroll
                      </v-btn>
                    </template>
                    <span>Unenroll users/groups from this course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" outlined small class="mr-1 action-button action-button-txt"
                        @click.prevent="archiveUserCourseData(item.id)" :disabled="item.is_course_archived">
                        <span>Archive Course Data</span>
                      </v-btn>
                    </template>
                    <span>Archiving the course data will reset the course for the user(s) who has completed the
                      course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="showManageDeadlinesPanel(item.id)" :disabled="item.is_course_archived">
                        Deadlines
                      </v-btn>
                    </template>
                    <span>Set & manage deadlines for this course</span>
                  </v-tooltip>
                  <!--click.prevent="showEnrolPanel(item.id, 3)"-->
                  <v-tooltip v-if="item.hasOwnProperty('test')" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="editTest(item.test.data.id)" :disabled="item.is_course_archived">
                        Test
                      </v-btn>
                    </template>
                    <span>Create, view or edit any tests for this course</span>
                  </v-tooltip>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="createTest(item.id)" :disabled="item.is_course_archived">
                        Test
                      </v-btn>
                    </template>
                    <span>Create Test</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-1 action-button action-button-txt" small outlined
                        @click.prevent="redirectTo('/admin/courses-report/' + item.id)"
                        :disabled="item.is_course_archived">
                        Reports
                      </v-btn>
                    </template>
                    <span>View User information for this course</span>
                  </v-tooltip>
                  <v-tooltip bottom class="mr-5" v-if="defaultUserEmail == 'defaultuser@improve.online'">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="$improve-grey-900"  :disabled="item.is_course_archived"
                        class="Frame-61 mr-1" @click.prevent="courseNotificationPanel(item.id,item.name)">
                        <v-icon small>fa fa-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Course Update Notification</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="$improve-grey-900"  :disabled="item.is_course_archived"
                        class="Frame-61 mr-1" @click.prevent="redirectTo('/admin/course-notification/' + item.id)">
                        <v-icon small>fa fa-bell</v-icon>
                      </v-btn>
                    </template>
                    <span>Configure notifications for this course.</span>
                  </v-tooltip>
                  <v-tooltip bottom class="mr-5" v-if="!item.is_course_archived">
                    <template v-slot:activator="{ on }">
                      <v-btn :id="item.id" v-on="on" x-small text color="$improve-grey-900" class="Frame-61 mr-1"
                        @click.prevent="archiveCourse(item.id, 1)" :disabled="item.is_partner_course">
                        <v-img class="archiveBtnImg" src="static/archive-icon.svg"
                          :style="{ opacity: item.is_partner_course ? 0.3 : 1 }"></v-img>
                      </v-btn>
                    </template>
                    <span>Archive Course</span>
                  </v-tooltip>
                  <v-tooltip bottom class="mr-5" v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn :id="item.id" v-on="on" x-small text color="$improve-grey-900" class="Frame-61 mr-1"
                        @click.prevent="archiveCourse(item.id, 0)" :disabled="item.is_partner_course">
                        <v-img class="archiveBtnImg" src="static/unarchive-icon.svg"
                          :style="{ opacity: item.is_partner_course ? 0.3 : 1 }"></v-img>
                      </v-btn>
                    </template>
                    <span>UnArchive Course</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="$improve-grey-900" @click.prevent="deleteCourse(item.id)"
                        class="Frame-61" :disabled="item.is_course_archived">
                        <v-icon small>fa fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete this course and all User data for it</span>
                  </v-tooltip>
                </template>
              </template>
            </v-data-table>
            </template>
            <template v-else>
              <v-row v-if="!loading" dense class="course-cards-grid" style="margin-bottom: 250px;">

                <v-col
                  v-for="course in courses"
                  :key="course.id"
                  cols="12"
                  sm="6"
                  md="4"
                  class="five-wide-col"
                >
                  <v-card class="modern-course-card" outlined>

                    <!-- IMAGE / THUMB -->
                    <div class="modern-card-image">
                      <div style="height: 155px; display: flex; justify-content: center; align-items: center; overflow: hidden;">
                        <v-img
                          :src="imgSrc(course)"
                          class="mx-auto"
                          max-height="100%"
                          max-width="100%"
                          cover
                        />
                      </div>

                     
                    </div>

                    <!-- CONTENT -->
                    <div class="modern-card-body">

                      <!-- TITLE + ENROL ROW -->
                      <div class="modern-card-title-row">
                        <div class="modern-card-title three-dots">
                          {{ course.name }}
                        </div>
                        

                        <v-switch
                          v-model="course.published"
                          class="modern-publish-switch"
                          color="primary"
                          inset
                          :disabled="course.is_course_archived"
                          @change="publishCourses(course.id, course.published)"
                        />
                      </div>
 <!-- Badges -->
                            <div class="modern-card-badges">
                              <v-chip
                                v-if="course.courseUpdateNotification && course.courseUpdateNotification.data.type === 'Update'"
                                x-small outlined class="square update"
                              >
                                UPDATED
                              </v-chip>

                              <v-chip
                                v-if="course.courseUpdateNotification && course.courseUpdateNotification.data.type === 'New'"
                                x-small class="square new"
                              >
                                NEW
                              </v-chip>

                              <!-- <v-chip
                                v-if="course.is_course_archived"
                                x-small outlined color="grey" class="square"
                              >
                                Archived
                              </v-chip> -->
                            </div>
                    </div>

                      <div class="modern-card-actions">
                        <div class="w-30 mb-2">
                        <!-- Primary actions -->
                          <v-btn
                            small text color="primary"
                            @click.prevent="redirectTo('/admin/courses/detail/' + course.id)"
                            :disabled="course.is_course_archived"
                            class="mr-2"
                          >
                            View
                          </v-btn>

                          <v-btn
                            small text color="primary"
                            @click.prevent="showEditPanel(course.id)"
                            :disabled="course.is_course_archived"
                            class="mr-2"
                          >
                            Details
                          </v-btn>

                          <v-btn
                            small text color="primary"
                            @click.prevent="redirectTo('/admin/courses/' + course.id)"
                            :disabled="course.is_course_archived"
                            class="mr-2"
                          >
                            Content
                          </v-btn>
                        </div>

                        <div class="w-100">
                          <!-- 🔔 Notification -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                text
                                color="$improve-grey-900"
                                :disabled="course.is_course_archived"
                                class="Frame-61 mr-1"
                                @click.prevent="redirectTo('/admin/course-notification/' + course.id)"
                              >
                                <v-icon small>fa fa-bell</v-icon>
                              </v-btn>
                            </template>
                            <span>Configure notifications for this course.</span>
                          </v-tooltip>

                          <!-- 📦 Archive -->
                          <v-tooltip bottom v-if="!course.is_course_archived">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                :id="course.id"
                                v-on="on"
                                x-small
                                text
                                color="$improve-grey-900"
                                class="Frame-61 mr-1"
                                @click.prevent="archiveCourse(course.id, 1)"
                                :disabled="course.is_partner_course"
                              >
                                <v-img
                                  class="archiveBtnImg"
                                  src="static/archive-icon.svg"
                                  :style="{ opacity: course.is_partner_course ? 0.3 : 1 }"
                                />
                              </v-btn>
                            </template>
                            <span>Archive Course</span>
                          </v-tooltip>

                          <!-- ♻️ Unarchive -->
                          <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                :id="course.id"
                                v-on="on"
                                x-small
                                text
                                color="$improve-grey-900"
                                class="Frame-61 mr-1"
                                @click.prevent="archiveCourse(course.id, 0)"
                                :disabled="course.is_partner_course"
                              >
                                <v-img
                                  class="archiveBtnImg"
                                  src="static/unarchive-icon.svg"
                                  :style="{ opacity: course.is_partner_course ? 0.3 : 1 }"
                                />
                              </v-btn>
                            </template>
                            <span>UnArchive Course</span>
                          </v-tooltip>

                          <!-- 🗑 Delete -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                text
                                color="$improve-grey-900"
                                class="Frame-61 mr-1"
                                @click.prevent="deleteCourse(course.id)"
                                :disabled="course.is_course_archived"
                              >
                                <v-icon small>fa fa-trash</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this course and all User data for it</span>
                          </v-tooltip>

                          <!-- ⋯ More actions menu -->
                          <v-menu offset-y >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small v-bind="attrs" v-on="on" style="float: right;">
                                <v-icon small>mdi-dots-horizontal</v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                              <v-list-item
                                v-for="action in getActionList(course)"
                                :key="action.name"
                                :disabled="action.is_course_archived"
                                @click="action.action()"
                              >
                                <v-list-item-title>
                                  {{ action.name }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </div>
                  </v-card>
                </v-col>
<div v-if="courses.length" v-observe-visibility="handleScrollLoadMore"></div>
                <v-col
                  v-if="loadingMoreCards"
                  v-for="n in 10"
                  :key="'more-skeleton-' + n"
                  cols="12"
                  sm="6"
                  md="4"
                  class="five-wide-col"
                >
                  <v-card class="modern-course-card" outlined>
                    <v-skeleton-loader type="image" height="200" />
                    <v-skeleton-loader type="heading" class="mt-3 mx-3" />
                    <v-skeleton-loader type="actions" class="px-3 pb-3" />
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import companyAPI from '@/api/company.js';
import courseAPI from '@/api/course.js';
import testAPI from '@/api/test.js';
import LayoutBasic from '@/layouts/Dashboard';
import TableThumb from '@/components/admin/course/TableThumb';
import EditCourse from '@/components/admin/course/Edit';
import CreateCourse from '@/components/admin/course/Create';
import ManageDeadlines from '@/components/admin/course/ManageDeadlines';
import RemoveUsers from '@/components/admin/course/RemoveUsers';
import CreateTest from '@/components/admin/course/AddTest';
import ShowCourseDetail from '@/components/admin/course/ShowCourseDetail';
import EnrolUsers from '@/components/admin/course/EnrolUsers';
import UnEnrolUsers from '@/components/admin/course/UnEnrolUsers';
import { screensize } from '../../utils/screensize';
import UpdateNotification from '../../components/admin/course/UpdateNotification.vue';
import { IMPROVE_CONFIG } from "@/config.js";
import thumbSizes from "@/utils/thumbs.js";

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'CoursesAdmin',
  components: {
    LayoutBasic,
    TableThumb,
  },
  beforeDestroy() {
    EventBus.$off('COURSES_UPDATED', this.getCourses());

    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScrollLoadMore);
    this.screenSize = null;
  },
  data() {
    return {
      headers: [
        {
          text: 'Published',
          value: 'published',
          sortable: false,
          align: 'center',
          class: 'published-th-text',
        },
        {
          text: 'Course Name',
          value: 'name',
          sortable: true,
          class: 'course-tbl-th',
        },
        { text: 'Action', value: 'id', sortable: false, align: 'left' },
      ],
      selectedAction: null,
      screenSize: currentScreenSize,
      coursePublish: true,
      courses: [],
      search: '',
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      selected: [],
      confirmDelete:
        'Are you sure you want to delete this Course? All Course users and associated data will be removed.',
      publishNotification:
        "Selected course(s) can not be published, it seems you didn't add any asset for this. Please upload at least one asset to publish it.",
      confirmArchive:
        'Are you sure you wish to archive course data for all users?',
      successMessage: 'Course Archived Successfully.',
      opens: 'center',
      isClearButtonVisible: false,
      locations: [],
      questionIconUrl: '/static/Vector-question.png',
      categories: [],
      selectedCategory: [],
      defaultUserEmail: this.$store.getters.user.email,
      selectedSort: 'view_all',
      sortOptions: [
        { label: 'View All', value: 'view_all' },
        { label: 'Name (A-Z)', value: 'name_asc' },
        { label: 'Name (Z-A)', value: 'name_desc' },
        { label: 'Recently Added', value: 'recently_added' },
        { label: 'Recently Updated', value: 'recently_updated' }
      ],
      apiRunning: false,
      viewMode: 'table',
      currentPage: 1,
      hasMore: true,
      loadingMoreCards: false,
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      const baseOptions =
        this.viewMode === 'table'
          ? this.options
          : { ...this.options, page: this.currentPage || 1 };
      return this.$gf.getQueryString(baseOptions, this.serverItemsLength);
    },
    hasTest: function () {
      return this.test == null ? false : true;
    },
    test: function () {
      return this.course.hasOwnProperty('test')
        ? this.course.test.data.id
        : null;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    options: {
      handler() {
        if (this.viewMode === 'table') {
          // normal server-side table pagination
          this.getCourses(false);
        }
      },
      deep: true,
    },
    viewMode(newVal, oldVal) {
      // persist choice
      localStorage.setItem('courses-view-mode', newVal);

      // reset scroll
      window.scrollTo({ top: 0, behavior: 'auto' });

      if (newVal === 'cards') {
        // 🔁 switching into cards: always start from page 1
        this.currentPage = 1;
        this.hasMore = true;
        this.courses = [];
        this.getCourses(true);
      } else if (newVal === 'table') {
        // 🔁 switching into table: reset table page to 1
        this.options = {
          ...this.options,
          page: 1,
        };
        this.getCourses(true);
      }
    },
  },
  mounted() {
    this.setEventBus();
    this.loadSearch();
    this.loadViewMode(); 
    this.handleResize();
    this.getCompanySites();
    this.getAllCourseCategories();
    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScrollLoadMore);

    // first page
    this.getCourses(true);
  },
  methods: {
    getActionList(item) {
      let actions = [
        {
          name: 'View',
          action: () => this.$router.push(`/admin/courses/detail/${item.id}`),
          is_course_archived: item.is_course_archived
        },
        { name: 'Details', action: () => this.showEditPanel(item.id), is_course_archived: item.is_course_archived },
        {
          name: 'Content',
          action: () => this.$router.push(`/admin/courses/${item.id}`),
          is_course_archived: item.is_course_archived
        },
        {
          name: 'Enrol',
          action: () => this.showEnrolPanel(item.id, 1, item.name),
          is_course_archived: item.is_course_archived
        },
        {
          name: 'Unenroll',
          action: () => this.showUnEnrolPanel(item.id, 1, item.name),
          is_course_archived: item.is_course_archived
        },
        { name: 'Archive Course Data', action: () => this.archiveUserCourseData(item.id), is_course_archived: item.is_course_archived },
        {
          name: 'Deadlines',
          action: () => this.showManageDeadlinesPanel(item.id),
          is_course_archived: item.is_course_archived
        },
        {
          name: 'Test',
          action: () => {
            item.hasOwnProperty('test')
              ? this.editTest(item.test.data.id)
              : this.createTest(item.id);
          },
          is_course_archived: item.is_course_archived
        },
        {
          name: 'Reports',
          action: () => this.$router.push(`/admin/courses-report/${item.id}`),
          is_course_archived: item.is_course_archived
        },
        {
          name: 'Configure notifications for this course',
          action: () => this.$router.push(`/admin/course-notification/${item.id}`),
          is_course_archived: item.is_course_archived
        },
        { name: 'Delete', action: () => this.deleteCourse(item.id), is_course_archived: item.is_course_archived },
      ];

      if(item.is_course_archived){
        actions.push({
          name: 'UnArchive Course',
          action: () => this.archiveCourse(item.id, 0),
        });
      }else{
        actions.push({
          name: 'Archive Course',
          action: () => this.archiveCourse(item.id, 1),
        });
      }

      if(this.defaultUserEmail == 'defaultuser@improve.online'){
        actions.push({
          name: 'Course Update Notification',
          action: () => this.courseNotificationPanel(item.id,item.name),
          is_course_archived: item.is_course_archived
        });
      }

      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    saveSearch() {
      // Save search value to localStorage
      if (this.search && this.search.length > 0) {
        localStorage.setItem('search-libary', this.search);
      } else {
        localStorage.removeItem('search-libary');
      }
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('search-libary');
      if (savedSearch !== null) {
        this.search = savedSearch;
      }
    },
    createTest(id) {
      testAPI.createTest(id).then((resp) => {
        this.$router.push('/admin/courses/test/' + resp.data.data.id);
      });
    },
    deleteCourse(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCourse(toast, id),
          },
        ],
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then((response) => {
        this.getCourses();
      });
    },
    editTest(id) {
      this.$router.push('/admin/courses/test/' + id);
    },
    publishCourses(cid, status) {
      if (status == null) status = false;
      this.loading = true;
      courseAPI.togglePublish(cid, status).then(() => {
        this.getCourses();
      });
      /*let selected = this.selected.map(function(x) {
        return x.id;
      });
      let totalAssets = this.selected.map(function(x) {
        return x.assets.data;
      });
      for(let i = 0; i <= totalAssets.length; i++){
        if(totalAssets[i]<=0) {
          this.$snotify.warning(this.publishNotification);
        } else {
          if(selected[i]!=undefined) {
            courseAPI.togglePublish(selected[i], true).then(resp => {
              this.getCourses();
            });
          }
        }
      }*/
    },
    unpublishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, false).then((resp) => {
        this.getCourses();
      });
    },
    applySearch() {
      this.options.page = 1;
      this.createSearchParams();
      this.saveSearch();
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.createSearchParams();
      this.saveSearch();
    },
    getCourses(reset = false) {
      if (this.apiRunning) return;

      if (this.viewMode === 'cards') {
        if (reset) {
          // First load / filters changed
          this.currentPage = 1;
          this.courses = [];
          this.hasMore = true;
          this.loading = true; // show initial skeleton cards
          this.loadingMoreCards = false;
        } else {
          // Loading more: keep existing cards visible (ghost cards shown via loadingMoreCards)
          this.loading = false;
        }
      } else {
        // TABLE MODE: always show skeleton while fetching,
        this.loading = true;
        this.loadingMoreCards = false;
      }

      this.apiRunning = true;

      this.searchParams =
        this.search && this.search.length > 0
          ? '&search=name:' + this.search
          : '';

      if (this.selectedCategory && this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }
      if (this.selectedSort) {
        this.searchParams += '&sorting=' + this.selectedSort.toString();
      }

      const queryString = this.params;

      courseAPI
        .getCoursesData(
          queryString + '&include=thumbnail,test,courseUpdateNotification',
          this.searchParams
        )
        .then((resp) => {
          const newCourses = resp.data.data;
          const pagination = resp.data.meta.pagination;

          this.pagination = pagination;

          if (this.viewMode === 'cards') {
            if (this.currentPage === 1 || reset) {
              this.courses = newCourses;
            } else {
              this.courses = this.courses.concat(newCourses);
            }

            const totalPages = Math.ceil(
              pagination.total / pagination.per_page
            );
            this.hasMore = pagination.current_page < totalPages;
          } else {
            this.courses = newCourses;
          }

          this.sortCourses();

          this.loading = false;
          this.loadingMoreCards = false;
          this.apiRunning = false;
        })
        .catch(() => {
          this.loading = false;
          this.loadingMoreCards = false;
          this.apiRunning = false;
        });
    },
    setEventBus() {
      EventBus.$on('COURSES_UPDATED', (payload) => {
        // this.params = payload;
        this.getCourses();
      });
      EventBus.$on('CATEGORY_UPDATED', () => {
        this.getAllCourseCategories();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreateTestPanel(id) {
      this.$showPanel({
        component: CreateTest,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCourse,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id, el, name = '') {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          elm: el,
          name: name,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    showUnEnrolPanel(id, el, name = '') {
      this.$showPanel({
        component: UnEnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          elm: el,
          name: name,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel(id) {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel(id) {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    /**
     * Show the course modal
     */
    showCourseDetail(id) {
      this.$showPanel({
        component: ShowCourseDetail,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    archiveUserCourseData(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          {
            text: 'Cancel',
            className: 'toast-cancel-button',
          },
          {
            text: 'Continue',
            action: (toast) => this.processArchiveUserCourseData(toast, id),
            className: 'toast-continue-button',
          },
        ],
      });
    },
    processArchiveUserCourseData(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveAllUserCourseData(id).then(() => {
        this.getCourses();
        this.$snotify.success(this.successMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    createSearchParams() {
      this.searchParams = '';
      this.options.page = 1;
      this.searchParams = this.params;
      if (this.search != null && this.search != '') {
        this.searchParams =
          this.params +
          '&search=name:' +
          this.search;
      } 

      if (this.selectedCategory) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }
      
      if(this.selectedSort != ''){
        this.searchParams += '&sorting=' + this.selectedSort.toString();
       }
      
      this.searchParams += '&include=thumbnail,test';
      this.getCourses(true);
    },
    getCompanySites() {
      companyAPI.getCompanySites().then(response => {
        this.locations = response.data.data;
      });
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.createSearchParams();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }
      this.createSearchParams();
    },
    archiveCourse(id,archived){
      let confirmArchive = 'Are you sure you want to archive the course? You have to unarchive the course if you would like to use it in the future';
      
      if(!archived)
       confirmArchive = 'Are you sure you wish to unarchive this course?';

      this.$snotify.confirm(confirmArchive, {
        backdrop: 0.3, buttons: [
          { text: 'Cancel',className: 'toast-cancel-button', },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) => this.processArchiveCourse(toast, id, archived),
          },      
        ],
      });
    },
    processArchiveCourse(toast, id,archived){
      this.$snotify.remove(toast.id);
      if(this.viewMode != 'cards')
        this.loading = true;
      courseAPI.archiveCourse(id,archived).then(() => {
        this.getCourses(true);
        // this.loading = false;
      }).catch(() => {
        this.$snotify.error(this.errorMessage);   
        this.loading = false;
      });
    },
    redirectTo(url){
      this.$router.push(url)
    },
     courseNotificationPanel(id, name) {
      this.$showPanel({
        component: UpdateNotification,
        disableBgClick: true,
        props: {
          id: id,
          name: name,
        },
        openOn: 'right',
      });
    },
    handleSortingChange() {
      this.options.page = 1;   // jump back to first page
      this.createSearchParams(); // this calls getCourses() -> sortCourses()
    },
    sortCourses() {
      if (!this.courses || !Array.isArray(this.courses)) return;
      

      const byNameAsc = (a, b) => {
        const an = (a.name || '').toLowerCase();
        const bn = (b.name || '').toLowerCase();
        return an.localeCompare(bn);
      };

      switch (this.selectedSort) {
        case 'name_asc':
          this.courses = [...this.courses].sort(byNameAsc);
          break;

        case 'name_desc':
          this.courses = [...this.courses].sort((a, b) => byNameAsc(b, a));
          break;

        case 'recently_added':
          // Try created_at, fall back to id if needed
          this.courses = [...this.courses].sort((a, b) => {
            const aDate = a.created_at || a.createdAt || a.id || 0;
            const bDate = b.created_at || b.createdAt || b.id || 0;
            return (bDate > aDate ? 1 : -1);
          });
          break;

        case 'recently_updated':
          this.courses = [...this.courses].sort((a, b) => {
            const aDate = a.updated_at || a.updatedAt || a.created_at || a.id || 0;
            const bDate = b.updated_at || b.updatedAt || b.created_at || b.id || 0;
            return (bDate > aDate ? 1 : -1);
          });
          break;

        case 'view_all':
        default:
          // Don’t touch order – use whatever backend sends
          break;
      }
    },
    imgSrc(course) {
      if (course.thumbnail != null) {
        if (course.thumbnail.hasOwnProperty('data')) {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: course.thumbnail.data.key,
            edits: thumbSizes.medium_new,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        } else {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: course.thumbnail.key,
            edits: thumbSizes.medium_new,
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        }
      } else {
        return 'https://placehold.co/350/000/fff?text='+ course.name;
      }
    },
    loadMoreCourses() {
      // avoid double calls
      if (this.loading || this.loadingMoreCards || this.apiRunning || !this.hasMore) return;

      this.currentPage += 1;
      this.loadingMoreCards = true; // show the 10 ghost cards
      this.getCourses(false);       // append
    },
    handleScrollLoadMore(isVisible) {
       if (!isVisible) return;
       if (this.viewMode !== 'cards') return;
       if (!this.hasMore || this.loading || this.loadingMoreCards || this.apiRunning) return;

      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop;
      const viewportHeight = window.innerHeight || doc.clientHeight;
      const scrollHeight = doc.scrollHeight;

      // how many pixels are left until the bottom
      const distanceFromBottom = scrollHeight - (scrollTop + viewportHeight);

      if (distanceFromBottom < 120) {
        this.loadMoreCourses();
      }
    },
    loadViewMode() {
      const saved = localStorage.getItem('courses-view-mode');
      if (saved === 'table' || saved === 'cards') {
        this.viewMode = saved;
      }
    },
  },
};
</script>
<style scoped>
.p-0{
  padding-left: 5px;
}
.course-filter{
  padding: 12px;
  gap: 25px;
}
.course-filter .search-box{
  border-radius: 25px;
  max-width: 300px !important;
  height: 40px;
  margin-top: 0;
}
.archiveBtnImg{
  width: 20px;
}
.v-btn.v-btn--disabled{
  color: #fff !important;
  pointer-events: auto;
  cursor: not-allowed;
  background-color: rgba(0, 0, 0, 0.26) !important
}
.square{
width: 79px;
height: 23px;
border-radius: 4px;
border-width: 2px;
/* margin: 0 auto; */
display: block;
}
.update{
color: #FF9D3B;
border-color: #FF9D3B;
}
.new{
 background-color: var(--v-primary-base) !important;
 color: #fff;
 border-color: var(--v-primary-base);
}

.selected-option {
  background-color: #f1f8f4 !important; /* Light greenish bg */
  border-left: 3px solid #43a047; /* Green border for emphasis */
  transition: background 0.2s;
}
.course-sorting{
    border-radius: 25px;
    height: 40px !important;
    background-color: #f3f4f6;
    border-color: #f3f4f6;
    padding-top: 5px;
    margin-top: 0;
    padding: 0 16px;
}

.modern-course-card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
  transition: all 0.18s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modern-course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
}

/* Publish switch floating */
.modern-publish-switch {
  position: relative;
  top: 8px;
  transform: scale(0.85);
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
}

.modern-card-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Badges */
.modern-card-badges {
  bottom: 8px;
  left: 8px;
  display: flex;
  gap: 6px;
}

/* Title & body */
.modern-card-body {
  padding: 12px 14px 8px;
}

.modern-card-title {
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  color: #0f172a;
  line-height: 1.3;
}

/* Actions bar */
.modern-card-actions {
  margin-top: auto;
  padding: 6px 10px 10px;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f1f5f9;
}

/* 5-wide grid on large screens */
@media (min-width: 1280px) {
  .five-wide-col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>